import React from 'react'


interface IProps {
    videoId: string
}

const YouTubeEmbed: React.FC<IProps> = ({videoId}) => {
  return (
    <div className=' flex justify-center items-center'>
      <iframe
        height="400"
        src={`https://www.youtube.com/embed/${videoId}`}
        // frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded YouTube Video"
        className=' rounded w-10/12'
      ></iframe>
    </div>
  )
}

export default YouTubeEmbed;